import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class _AES_EncryptionService {
  private readonly key = "UkJZa3psQjlzYkJIM0tGRXVJYT";

  private _cryptoJS: any = null;
  private _loadPromise: Promise<any> | null = null;

  // Call this once from AppComponent.ngOnInit() — non-blocking background preload
  async preload(): Promise<void> {
    if (this._cryptoJS) {
      return;
    }
    if (this._loadPromise) {
      await this._loadPromise;
      return;
    }
    this._loadPromise = import("crypto-js").then((mod) => {
      this._cryptoJS = mod.default ?? mod;
      this._loadPromise = null;
    });
    await this._loadPromise;
  }

  private get CryptoJS(): any {
    if (!this._cryptoJS) {
      throw new Error(
        "[AES] CryptoJS not loaded yet. Ensure preload() completed before encrypt/decrypt.",
      );
    }
    return this._cryptoJS;
  }

  private getKey(): any {
    const CryptoJS = this.CryptoJS;
    const keyBytes = CryptoJS.enc.Utf8.parse(this.key);
    const keyHex = keyBytes
      .toString(CryptoJS.enc.Hex)
      .padEnd(64, "0")
      .substring(0, 64);
    return CryptoJS.enc.Hex.parse(keyHex);
  }

  private getIV(): any {
    const CryptoJS = this.CryptoJS;
    const ivStr = CryptoJS.SHA256(this.key).toString().substring(0, 16);
    return CryptoJS.enc.Utf8.parse(ivStr);
  }

  encrypt(plainText: string): string {
    const CryptoJS = this.CryptoJS;
    const encrypted = CryptoJS.AES.encrypt(plainText, this.getKey(), {
      iv: this.getIV(),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  decrypt(encryptedText: string): string {
    const CryptoJS = this.CryptoJS;
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedText, this.getKey(), {
        iv: this.getIV(),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const result = decrypted.toString(CryptoJS.enc.Utf8);
      if (!result) throw new Error("Empty result");
      return result;
    } catch (e) {
      return "";
    }
  }
}
